import { render, staticRenderFns } from "./Skip.vue?vue&type=template&id=6fbd726a"
import script from "./Skip.vue?vue&type=script&lang=ts"
export * from "./Skip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports